<p>help-shopify-identity-merchant works!</p>
